import React from "react";
import { connect } from "react-redux";
import ReactTimeout from 'react-timeout';
import {Link} from 'react-router-dom';

import SendMessage from './Chat/SendMessage';
import Result from './Result';
import Success from './Success';
import Dialog from './Chat/Dialog';
import { isEmpty } from "../../helper";
import { getExecutorMessages, getExecutorMoreMessages, getExecutorPhotos, getExecutorVideos, sendMessage } from '../../actions/orderActions';

class MessageListItem extends React.Component {

    constructor() {
        super();
        this.state = {
            toggle_dialog: true,
            chat_message: '',
            sending: false,
        };
    }

    componentWillMount() {
        const {
            dispatch,
            executor:{id,status},
            choiceComponent,
            session:{currentUser},
            currentOrder,
        } = this.props;

        const isCustomer = currentOrder.user_id === currentUser.id;

        if ("undefined" !== typeof id) {
            dispatch(getExecutorMessages(id));

            if(choiceComponent === "Result") {
                dispatch(getExecutorPhotos(id));
                dispatch(getExecutorVideos(id));
            }
        }

        this.launchingInterval(id, isCustomer);
    }

    launchingInterval(bid, isCustomer) {
        const {dispatch, executor} = this.props;

        let bid_id = bid ? bid : executor.id

        this.interval = this.props.setInterval(() => {
            dispatch(getExecutorMessages(bid_id));
            if(executor.status < 4){
                dispatch(getExecutorPhotos(bid_id));
                dispatch(getExecutorVideos(bid_id));
            }
        }, 30000);
    }

    componentWillUnmount() {
        this.props.clearInterval(this.interval);
    }

    toggleChatContent(event) {
        this.setState({
            toggle_dialog: !this.state.toggle_dialog
        });

        event.preventDefault();
    }

    submitSendMessage(e) {
        e.preventDefault();

        const {executor:{id}, dispatch} = this.props;
        const {chat_message} = this.state;

        if (isEmpty(chat_message) && id) {

            let params = {bid_id: id, content: chat_message}

            this.setState({
                sending: true,
            })

            dispatch(
                sendMessage(
                    params,
                    () => this.setState({
                        chat_message: '',
                        sending: false
                    })
                )
            );
        }
    }

    handleRequestMoreMessage() {
        const { dispatch, executor } = this.props;
        const message = executor.messages.results[0];

        dispatch(getExecutorMoreMessages({bid_id:executor.id, last_message_id:message.id, new_messages:1}));
    }

    onBlackListClick(e) {
        e.preventDefault();
        this.props.handleBlacklistClick(this.props.executor.user);
    }

    render() {
        const { executor, currentOrder, session:{currentUser, isLoggedIn}, data } = this.props;
        const isCustomer = currentOrder.user_id === currentUser.id;
        const isInBlacklst = (currentUser.blacklist_users || []).filter(user => user.id === executor.user.id).length;
        const settings = data["settings"];

        if(!executor) return false;

        if(!isCustomer && executor.status === 7) {
            return  <div className="actions">
                        <h3 style={{color:'red', fontSize:'15px'}}>{'Отклик был отклонен автоматически'}</h3>
                    </div>
        }

        let itsMyBid = (currentUser.id === executor.user_id);

        return (
            <li>
                <div className="executor-serial">#{this.props.index}</div>
                <div className="executor-content">
                    <div className="name-and-blacklist">
                        <Link className="name" to={`/profile/${executor.user.id}`}>{executor.user.first_name} {executor.user.last_name}</Link>

                        {
                            !isLoggedIn ? null :
                            <div>
                            {
                                isCustomer ?
                                isInBlacklst ?
                                <span className='text_red'>Пользователь в черном списке</span>
                                :
                                <a href='' onClick={(e) => this.onBlackListClick(e)}>В черный список</a>
                                : null
                            }
                            </div>
                        }
                    </div>
                    <strong className="rating">
                        <span className="like text_green">+{executor.user.like_count}</span>
                        <pre> / </pre>
                        <span className="dislike text_red">-{executor.user.dislike_count}</span>
                    </strong>

                    {
                        (itsMyBid || isCustomer) && !currentOrder.is_test ?
                        <Dialog
                            messages={executor.messages}
                            toggle={this.state.toggle_dialog}
                            toggleChatContent={(e) => this.toggleChatContent(e)}
                            loadMoreMessage={() => this.handleRequestMoreMessage()}
                            />
                        : null
                    }

                    {
                        (itsMyBid || isCustomer) && executor.is_messages_enabled && !currentOrder.is_test && !currentOrder.is_failed && !this.props.dateForSettingsBoolean
                        ?
                        <SendMessage
                            chat_message={this.state.chat_message}
                            handleMessage={(value) => this.setState({chat_message: value})}
                            submitSendMessage={(e) => this.submitSendMessage(e)}
                            sending={this.state.sending}
                            />
                        : null
                    }


                    <Result
                        isLoggedIn={isLoggedIn}
                        isCustomer={isCustomer}
                        executor={executor}
                        currentUserId={currentUser.id}
                        uploadWorks={this.props.uploadWorks}
                        uploadState={this.props.uploadState}
                        openArbitragePopup={this.props.openArbitragePopup}
                        handleAcceptWork={this.props.handleAcceptWork}
                        deleteImageInServer={this.props.deleteImageInServer}
                        deleteVideoInServer={this.props.deleteVideoInServer}
                        inputTypeFileValue={this.props.inputTypeFileValue}
                        fileReaderResults={this.props.fileReaderResults}
                        currentOrder={currentOrder}
                        endShootingDatetime={this.props.endShootingDatetime}
                        dateForSettingsBoolean={this.props.dateForSettingsBoolean}
                        settings={settings}
                    />

                    {
                        !isCustomer && executor.status === 6
                        ?
                        <div className="actions">
                            <h3 style={{color:'red', fontSize:'15px'}}>
                                {currentOrder.is_my_bid ? 'Вы не выполнили заказ.' : 'Заказ не выполнен'}
                            </h3>
                        </div>
                        : null
                    }

                    {
                        isCustomer && executor.status === 4
                        && (executor.complaints && executor.complaints.length)
                        ?
                        <div className="actions">
                            <h3 style={{color:'red', fontSize:'15px'}}>
                                {'Ваша жалоба была отклонена'}
                            </h3>
                        </div>
                        : null
                    }

                    {
                        executor.status === 4 || executor.status === 8 ?
                        <Success
                            isCustomer={isCustomer}
                            executor={executor}
                            itsMyBid={itsMyBid}
                            currentOrder={currentOrder}
                            evaluateWork={this.props.evaluateWork}
                            openShareModal={this.props.openShareModal}
                            downloadWork={this.props.downloadWork}
                            isFetching={this.props.isFetching}
                            />
                        : null
                    }

                </div>
            </li>
        )
    }
}

const mapStateToProps = state => {
    return {
        ...state
    };
};

export default ReactTimeout(connect(mapStateToProps)(MessageListItem));


// WEBPACK FOOTER //
// ./src/components/MakeOrder/MessageListItem.js